import CopyButton from './CopyButton.tsx';
import StringField from './StringField.tsx';

interface CopyFieldProps {
    // A visible label, or only one for screen readers where the dialog's text says what it is.
    label?: string;
    'aria-label'?: string;
    value: string;
    helpText?: string;
}

// A value to pass on or paste elsewhere, e.g. a link or a URL, read-only and selected on focus, with a button that
// copies it.
const CopyField = ({ label, 'aria-label': ariaLabel, value, helpText }: CopyFieldProps) => (
    <div className="flex flex-col gap-1.5">
        <div className="flex items-end gap-2">
            <StringField
                label={label}
                aria-label={ariaLabel}
                value={value}
                isReadOnly
                className="min-w-0 flex-1"
                onFocus={(event) => (event.target as HTMLInputElement).select()}
            />
            <CopyButton value={value} />
        </div>
        {helpText && <p className="text-sm text-text-muted">{helpText}</p>}
    </div>
);

export default CopyField;
